export const visit = (vm, at) => {
vm(require("customer-data-properties/lang/en.lyaml"));
vm(require("customer-data-reference-ui-components/lang/en.lyaml"));
vm(require("crm-component-utils/lang/en.lyaml"));
at({ "en": { "crmDataHighlights": { "fetchError": "There was an error loading your data. Please refresh the page to try again.", "emptyHeader": "No statistics to show right now", "emptyBody": "Important metrics about this record will be shown here." } } });
};